import AdminCrud from "@/pages/admin/components/AdminCrud";
import type { CrudField } from "@/pages/admin/components/AdminCrud";

const fields: CrudField[] = [
  { key: "title", label: "Titre", required: true },
  { key: "description", label: "Description", type: "textarea" },
  { key: "icon", label: "Icône", type: "icon" },
];

export default function AdminArguments() {
  return (
    <AdminCrud
      title="Arguments"
      description="Les raisons de nous soutenir (« Pourquoi nous soutenir ? »)."
      addLabel="Ajouter un argument"
      table="why_support"
      fields={fields}
      listTitleKey="title"
      listSubtitleKey="description"
      listIconKey="icon"
    />
  );
}